export enum TwoFactorSetupStep {
  Method = 'method',
  TotpSetup = 'totp_setup',
  EmailSetup = 'email_setup',
  BackupCodes = 'backup_codes'
}
